import {ParsedTabsResponse} from '@mintdata-wsp/common/controllers/network/extended/responses/ParsedTabsResponse';
import {ResolutionResponse} from '@mintdata-wsp/common/controllers/network/extended/responses/ResolutionResponse';
import {Fetcher, OnUploadProgress} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {FileResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/FileResponse';
import {UploadedFileResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/UploadedFileResponse';
import {
    Excel as BaseExcel,
    Files as BaseFiles,
    Profile as BaseProfile,
    Proxy as BaseProxy,
    Resolution as BaseResolution,
    WspAPI as BaseWspAPI
} from '@mintdata-wsp/common/controllers/network/generated/WspAPI';

export class Resolution extends BaseResolution
{
    constructor(private _fetcher:Fetcher)
    {
        super(_fetcher);
    }

    resolve(resolutionRequest:any):Promise<ResolutionResponse>
    {
        const __responseTypeCtor = ResolutionResponse;
        const __apiPath = '/api/resolution';
        const __method = 'post';

        return this._fetcher.request(__method, __apiPath, __responseTypeCtor, null, resolutionRequest);
    }
}

export class Excel extends BaseExcel
{
    private _fetcher:Fetcher;

    constructor(http:Fetcher)
    {
        super(http);

        this._fetcher = http;
    }

    upload(data?:FormData, onProgress?:OnUploadProgress):Promise<UploadedFileResponse>
    {
        const __responseTypeCtor = UploadedFileResponse;
        const __apiPath = '/api/excel/upload';
        const __method = 'post';

        return this._fetcher.request(__method, __apiPath, __responseTypeCtor, null, data, null, onProgress);
    }

    parse(excelFileParseRequest:any):Promise<ParsedTabsResponse>
    {
        const __responseTypeCtor = ParsedTabsResponse;
        const __apiPath = '/api/excel/parse';
        const __method = 'post';

        return this._fetcher.request(__method, __apiPath, __responseTypeCtor, null, excelFileParseRequest);
    }

    parseCsv(csvFileParseRequest:any):Promise<ParsedTabsResponse>
    {
        const __responseTypeCtor = ParsedTabsResponse;
        const __apiPath = '/api/excel/parsecsv';
        const __method = 'post';

        return this._fetcher.request(__method, __apiPath, __responseTypeCtor, null, csvFileParseRequest);
    }
}

export class Files extends BaseFiles
{
    private _fetcher:Fetcher;

    constructor(http:Fetcher)
    {
        super(http);

        this._fetcher = http;
    }

    uploadFile(organizationSid:any, data?:FormData, onProgress?:OnUploadProgress, uploadCancelledPromise?:Promise<any>):Promise<FileResponse>
    {
        const __responseTypeCtor = FileResponse;
        const __apiPath = '/api/organization/' + organizationSid + '/files/upload';
        const __method = 'post';

        return this._fetcher.request(__method, __apiPath, __responseTypeCtor, null, data, null, onProgress, uploadCancelledPromise);
    }
}

export class Proxy extends BaseProxy
{
    private _fetcher:Fetcher;

    constructor(http:Fetcher)
    {
        super(http);
        this._fetcher = http;
    }

    proxyRequest(proxyRequest:any):Promise<Response>
    {
        const __apiPath = '/api/fetch';
        const __method = 'post';

        return this._fetcher.requestWithoutProcessing(__method, __apiPath, null, proxyRequest);
    }
}

export class Profile extends BaseProfile
{
    private _fetcher:Fetcher;

    constructor(http:Fetcher)
    {
        super(http);
        this._fetcher = http;
    }

    getWithoutProcessing():Promise<Response>
    {
        const __apiPath = '/api/profile';
        const __method = 'get';

        return this._fetcher.requestWithoutProcessing(__method, __apiPath, null, null);
    }
}

export class WspAPI extends BaseWspAPI
{
    public readonly resolution:Resolution | any;
    public readonly excel:Excel;
    public readonly files:Files;
    public readonly proxy:Proxy;
    public readonly profile:Profile;

    private _fetcher:Fetcher;

    constructor(http:Fetcher)
    {
        super(http);

        this._fetcher = http;

        this.resolution = new Resolution(http);
        this.excel = new Excel(http);
        this.files = new Files(http);
        this.proxy = new Proxy(http);
        this.profile = new Profile(http);
    }

    public overrideBaseUrl(newBaseUrl:string)
    {
        return new WspAPI(this._fetcher.overrideBaseUrl(newBaseUrl));
    }
}
